// src/pages/NotFound.jsx
import { useNavigate } from 'react-router-dom';
import '../styles/NotFound.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <h1>404</h1>
      <h2>Page introuvable</h2>
      <p>La page que vous cherchez n'existe pas ou a été déplacée.</p>

      <button
        className="back-home-btn"
        onClick={() => navigate('/')}
      >
        Retour à l'accueil
      </button>
    </div>
  );
}
